module.exports = __webpack_public_path__ + "img/logo2.f3f2116c.svg";